import React, { useState } from 'react';
import { X, Tag as TagIcon } from 'lucide-react';

/**
 * Lightweight tag input. Accepts comma- or Enter-separated values,
 * displays chips with remove buttons.
 *
 *   <TagsInput value={tags} onChange={setTags} placeholder="add tag" />
 */
export default function TagsInput({ value = [], onChange, placeholder = 'Add tag and press Enter', testIdPrefix = 'tag' }) {
  const [draft, setDraft] = useState('');

  const commit = (raw) => {
    const next = raw.split(',').map(t => t.trim()).filter(Boolean);
    if (!next.length) return;
    const merged = Array.from(new Set([...(value || []), ...next]));
    onChange(merged);
    setDraft('');
  };

  const remove = (t) => {
    onChange((value || []).filter(x => x !== t));
  };

  return (
    <div className="flex flex-wrap gap-2 items-center px-2 py-1.5 rounded-md border border-slate-200 bg-transparent min-h-[38px]">
      {(value || []).map((t, i) => (
        <span key={t} data-testid={`${testIdPrefix}-chip-${i}`} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs bg-amber-100 text-amber-800 border border-amber-200">
          <TagIcon className="w-3 h-3" />{t}
          <button type="button" onClick={() => remove(t)} className="hover:text-amber-900" data-testid={`${testIdPrefix}-remove-${i}`}>
            <X className="w-3 h-3" />
          </button>
        </span>
      ))}
      <input
        data-testid={`${testIdPrefix}-input`}
        type="text"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            commit(draft);
          } else if (e.key === 'Backspace' && !draft && (value || []).length) {
            remove(value[value.length - 1]);
          }
        }}
        onBlur={() => draft && commit(draft)}
        placeholder={placeholder}
        className="flex-1 min-w-[120px] bg-transparent outline-none text-sm text-slate-700"
      />
    </div>
  );
}
